import React, { useState, useEffect } from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import styled from "styled-components";
import theme from "prism-react-renderer/themes/nightOwl";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Pre = styled.pre`
  font-family: "Merriweather", "Georgia", serif;
  text-align: left;
  margin: 1em 0;
  padding: 0.5em;
  overflow-x: auto;
`;

const Line = styled.div`
  display: table-row;
`;

const LineNo = styled.span`
  display: table-cell;
  text-align: right;
  padding-right: 1em;
  user-select: none;
  opacity: 0.5;
`;

const LineContent = styled.span`
  display: table-cell;
`;

function Code({ code, language }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  return (
    <div className="code-container">
      <CopyToClipboard text={code} onCopy={() => setCopied(true)}>
        <span className="clipboard">
          <i className="fas fa-copy"></i>
          <p>{copied && <i className="fas fa-check"></i>}</p>
        </span>
      </CopyToClipboard>

      <Highlight
        {...defaultProps}
        theme={theme}
        code={code}
        language={language}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <Pre className={className} style={style}>
            {tokens.map((line, i) => (
              <Line key={i} {...getLineProps({ line, key: i })}>
                <LineNo>{i + 1}</LineNo>
                <LineContent>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token, key })} />
                  ))}
                </LineContent>
              </Line>
            ))}
          </Pre>
        )}
      </Highlight>
    </div>
  );
}

export default Code;
